let backgroundColor;

export function setPDPBackgroundColor(color: string) {
    backgroundColor = color;
}

export function getPDPBackgroundColor() {
    return backgroundColor;
}